import { render, staticRenderFns } from "./outsideConfirm.vue?vue&type=template&id=264c5426&scoped=true"
import script from "./outsideConfirm.vue?vue&type=script&lang=js"
export * from "./outsideConfirm.vue?vue&type=script&lang=js"
import style0 from "./outsideConfirm.vue?vue&type=style&index=0&id=264c5426&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264c5426",
  null
  
)

export default component.exports